import { Link, useLocation } from 'react-router-dom';
import { Home, BookOpen, Briefcase, User, LayoutDashboard, Settings, Megaphone } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export const MobileNav = () => {
  const location = useLocation();
  const { isAuthenticated, isAdmin } = useAuth();

  const navItems = isAdmin
    ? [
        { icon: Home, label: 'Home', path: '/' },
        { icon: LayoutDashboard, label: 'Dashboard', path: '/admin' },
        { icon: BookOpen, label: 'Resources', path: '/resources' },
        { icon: Megaphone, label: 'Advertise', path: '/advertise' },
        { icon: Settings, label: 'Settings', path: '/admin' },
      ]
    : [
        { icon: Home, label: 'Home', path: '/' },
        { icon: BookOpen, label: 'Resources', path: '/resources' },
        { icon: Megaphone, label: 'Advertise', path: '/advertise' },
        { icon: Briefcase, label: 'Jobs', path: '/vacancies' },
        { icon: User, label: 'Profile', path: isAuthenticated ? '/dashboard' : '/login' },
      ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 h-16 glass-card border-t border-white/10 flex justify-around items-center z-50 md:hidden">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return (
          <Link
            key={item.path + item.label}
            to={item.path}
            data-testid={`nav-${item.label.toLowerCase()}`}
            className={`flex flex-col items-center gap-1 px-3 py-2 transition-colors ${
              isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon className="h-5 w-5" />
            <span className="text-[10px] font-medium">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};
